import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Mtrwf } from '../entity/Mtrwf-angular';


@Injectable({
  providedIn: 'root'
})
export class MtrwfServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Mtrwf();
    this.entityType.type = EntityType.data;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      WF001: '編號', WF002: '使用者', WF003: '分類', WF004: '名稱', WF005: '網址', WF006: '自行排序碼', WF007: '點閱次數', WF008: '上層編號'
    };

    this.fieldNames = 'WF001,WF002,WF003,WF004,WF005,WF006,WF007,WF008';
    this.fieldLengths = { WF001: 6, WF002: 10, WF003: 10, WF004: 60, WF005: 255, WF006: 4, WF007: 6, WF008: 6 };
    this.columnDefs = [
      { field: "WF001", headerName: "編號", headerTooltip: "", width: 118, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "WF002", headerName: "使用者", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "WF003", headerName: "分類", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "WF004", headerName: "名稱", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "WF005", headerName: "網址", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "WF006", headerName: "自行排序碼", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "WF007", headerName: "點閱次數", headerTooltip: "", width: 118, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "WF008", headerName: "上層編號", headerTooltip: "", width: 118, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'MTRWF';
    this.isSys = false;
    this.sqlSelect = `SELECT MTRWF.*  FROM MTRWF`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY WF001`;
    this.keyFields = ['WF001'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['WF001'];
    this.seqField = '';
    this.seqFieldLength = 0;
  }
  override async validateItem(item: Mtrwf): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem: Mtrwf): Promise<Mtrwf> {
    await super.newRecord(newItem);
    return newItem;
  }




}

